var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconS32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5066 5.53761C20.9959 5.02661 20.3894 4.62125 19.722 4.34469C19.0545 4.06813 18.3391 3.92578 17.6166 3.92578C16.8941 3.92578 16.1787 4.06813 15.5113 4.34469C14.8438 4.62125 14.2374 5.02661 13.7266 5.53761L12.6666 6.59761L11.6066 5.53761C10.5749 4.50591 9.17566 3.92632 7.71662 3.92632C6.25759 3.92632 4.85831 4.50591 3.82662 5.53761C2.79493 6.5693 2.21533 7.96857 2.21533 9.42761C2.21533 10.8866 2.79493 12.2859 3.82662 13.3176L4.88662 14.3776L12.6666 22.1576L20.4466 14.3776L21.5066 13.3176C22.0176 12.8069 22.423 12.2004 22.6995 11.533C22.9761 10.8655 23.1184 10.1501 23.1184 9.42761C23.1184 8.70512 22.9761 7.98971 22.6995 7.32225C22.423 6.65479 22.0176 6.04836 21.5066 5.53761V5.53761Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconS32);
export default __webpack_public_path__ + "static/media/icon-s3-2.06610c79164ae1e279810a83d0ced7cc.svg";
export { ForwardRef as ReactComponent };